import styled from '@emotion/styled';
import { COLORS_BACKGROUND } from '@zola/zola-ui/src/styles/emotion/colors';

export const OuterContainer = styled.div`
  background-color: ${COLORS_BACKGROUND.JEWEL_4};
  height: 100%;
  width: 100%;
`;
